import { SxProps, Theme } from '@rossum/ui/material';

export const OPTION_INPUT_WIDTH = 170;

export const optionRowSx: SxProps<Theme> = {
  alignItems: 'center',
  mt: '10px',
  width: 404,
};
